import React from 'react';
import  { Redirect } from 'react-router-dom';
import {
 Alert , 
    Row, Col,
} from 'reactstrap';

/*import {
 Alert , UncontrolledAlert ,
    Row, Col,
} from 'reactstrap';*/

import {
    
} from 'components';

import {UserProfile} from 'components';
import logofull from "assets/img/logo-full.png";
class Login extends React.Component{
   
/*   const contactSubmit = data => {
    console.log(data);
  }; */

  constructor(props){
    super(props);
     this.state = {
           fields: {cname: '', pass: '' },
           errors: {cname:'',pass:''},
           alertvisible:false,
           alesrtsuccessmess:""
       }
       this.onDismiss = this.onDismiss.bind(this);
  }

  handleValidation(){
        let fields = this.state.fields;
        let err = this.state.errors;
        let formIsValid = true;

        //Name
        if(fields.cname==""){
           formIsValid = false;
           err.cname = "Cannot be empty";
        }
        else
        {
        //if(typeof fields.cname !== "undefined"){
           if(!fields.cname.match(/^[a-zA-Z.]+$/)){
              formIsValid = false;
              err.cname = "Only letters";
           }        
        //}
        }

        //pass
        if(fields.pass==""){
           formIsValid = false;
           err.pass = "Cannot be empty";
        }
        else
        {
            //if(typeof fields.pass !== "undefined"){
                if(!fields.pass.match(/^[a-zA-Z.0-9]+$/)){
                    formIsValid = false;
                  err.pass = "Only Numbers and alphabets";
                }        
            //}
        }

        /*if(typeof fields["email"] !== "undefined"){
           let lastAtPos = fields["email"].lastIndexOf('@');
           let lastDotPos = fields["email"].lastIndexOf('.');

           if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') == -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
              formIsValid = false;
              errors["email"] = "Email is not valid";
            }
       } */ 

       this.setState({errors:err});
       return formIsValid;
   }
    
    contactSubmit(e){
        e.preventDefault();
        var BASEDIR = process.env.REACT_APP_BASEDIR;
        const { history } = this.props;

        const formData = new FormData(); 
        formData.append("uname",this.state.fields.cname);
        formData.append("pass",this.state.fields['pass']);

    ///console.log(this.state.fields);
        if(this.handleValidation()){
              let userdet="";
              this.loginapi="https://salasartech.com/datasheet/api/userexist";
                  fetch(this.loginapi, {
                                method: 'POST',
                                body: formData,
                                    
                  }).then(function(response) {
                      if(response.ok) {
                          return response.json();
                      }

                      })
                  .then(res => {
                      //console.log(res);

                      if(res.uid>0)
                      {
                             UserProfile.setUid(res.uid);
                             UserProfile.setName(res.name);
                             this.props.history.push(BASEDIR+"/layout5");
                      }
                      else
                      {
                             // alert("Login Failed");
                             this.setState({alesrtsuccessmess:"Sorry! Please Try Again!",alertvisible:true});
                            this.setState(prevState => {
                            prevState.fields['cname'] = '';
                            prevState.fields['cpass'] = '';
                             });
                            return true;
                      }
                    });
                      console.log("userdet="+userdet);

                      /*
            if ((this.state.fields['cname'] === 'ashlok' && this.state.fields['pass'] === '123456')) {
                console.log("valid user");
                   this.props.history.push(BASEDIR+"/layout5");
                }
                else{
                        //alert("Login Failed");
                         this.setState({alesrtsuccessmess:"Sorry! Please Try Again!",alertvisible:true});
                        this.setState(prevState => {
                        prevState.fields['cname'] = '';
                        prevState.fields['cpass'] = '';

                        });
                    return true;
                }*/

           
        }else{
           //alert("invalid user");
           this.setState({alesrtsuccessmess:"Sorry! Please Try Again!",alertvisible:true});
                    return false;
        }

    }

    handleChange(field, e){
      /*       
        let fields = this.state.fields;
        fields[field] = e.target.value;        
        this.setState({fields}); */
        let name = e.target.name;
        let value = e.target.value;
       
           this.setState(prevState => {
                prevState.fields[name] =  value;
                return {
                        fields: prevState.fields
                        };
             });
    }

    onDismiss() {
    this.setState({ alertvisible: false });
  }

    render(){

        return (
            <div>
                <div className="">
                    <Row>
                        <Col xs={12} md={12}>

        <div className="container-fluid">
            <div className="login-wrapper row">
                <div id="login" className="login loginpage offset-xl-4 offset-lg-3 offset-md-3 offset-0 col-12 col-md-6 col-xl-4">
                    {/*<h2><a href="#!" title="Login Page" tabIndex="-1">Ashlok</a></h2>*/}
                    <center><img src={logofull} alt="react-logo" className="light-logo" /></center>
                    <Alert color="danger" isOpen={this.state.alertvisible} toggle={this.onDismiss}>
                          {this.state.alesrtsuccessmess}.
                    </Alert>
                    <form name="loginform" id="loginform"  method="post" onSubmit= {this.contactSubmit.bind(this)}>
                        <p>
                            <label htmlFor="user_login">Username<br/>
                                <input ref="name" type="text" name="cname" id="user_name" className="form-control" onChange={this.handleChange.bind(this, "cname")} value={this.state.fields.cname}/>
                                 <span style={{color: "red"}}>{this.state.errors.cname}</span>
                            </label>
                        </p>
                        <p>
                            <label htmlFor="user_pass">Password<br />
                                <input ref="pass" type="password" name="pass" id="user_pass" className="input" size="20" onChange={this.handleChange.bind(this, "pass")} value={this.state.fields.pass} /></label>
                                 <span style={{color: "red"}}>{this.state.errors.pass}</span>
                        </p>
                        <p className="submit">
                            <input type="submit" name="wp-submit" id="wp-submit" className="btn btn-accent btn-block" value="Sign In" />    
                        </p>
                    </form>
                    
                   
                    
                    
                </div>
            </div>
        </div>






                        </Col>

                    </Row>
                </div>
            </div>
        );
    }
}

export default Login;
